/**
 * 網站作者／開發者資訊（顯示於頁尾）
 * 若 name 留空則不顯示作者欄位
 */
export const siteAuthor = {
  /** 顯示名稱（例如：您的姓名、暱稱或「OO 單位技術支援」） */
  name: '陳竑仰',
  /** 選填：點擊名字時連到的網址（例如個人頁、email mailto:、或留空不連結） */
  url: '',
};

export default siteAuthor;
